import HomeIcon from '@material-ui/icons/Home';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StyledBreadcrumb } from 'utils/styles';
import { goTo } from 'utils/util';

export const HomeCrumb: React.FC = (): JSX.Element => <StyledBreadcrumb label="Home" icon={<HomeIcon fontSize="small" />} onClick={goTo('/home', useNavigate())} />;
